import React from "react";
import "./Services.css";
import { FaReact, FaLaptopCode, FaServer, FaRocket } from "react-icons/fa";
import pages from "./seoPages.json";

const services = [
  {
    icon: <FaReact />,
    title: "React.js Development",
    text: "Fast, component-driven React apps with hooks, Redux and clean, maintainable code, built for startups and growing businesses.",
    tags: ["React", "Redux", "Hooks"],
  },
  {
    icon: <FaLaptopCode />,
    title: "Websites & Landing Pages",
    text: "Responsive, SEO-friendly business websites, portfolios and landing pages that load quickly and convert visitors into clients.",
    tags: ["Responsive", "SEO-ready", "Fast"],
  },
  {
    icon: <FaServer />,
    title: "Full Stack with Java",
    text: "Secure REST APIs and databases with Java Spring Boot and MySQL, connected to a polished React frontend end to end.",
    tags: ["Spring Boot", "MySQL", "REST"],
  },
  {
    icon: <FaRocket />,
    title: "Performance & UI Fixes",
    text: "Already have a site? I improve speed, accessibility, mobile layout and Core Web Vitals without a full rebuild.",
    tags: ["Speed", "Accessibility", "Mobile"],
  },
];

const Services = () => (
  <section className="section services" id="services" aria-labelledby="services-title">
    <div className="container">
      <span className="section-tag reveal">Work with me</span>
      <h2 className="section-title reveal" id="services-title" style={{ "--d": "80ms" }}>
        Hire a React developer for <em>freelance</em> or full-time
      </h2>
      <p className="section-sub reveal" style={{ "--d": "140ms" }}>
        I'm Kiran Sable, a React developer in Pune working with clients across India and remotely worldwide. I'm open to
        freelance projects and full-time roles.
      </p>

      <div className="service-grid">
        {services.map((s, i) => (
          <article className="card service-card reveal" key={s.title} style={{ "--d": `${i * 80}ms` }}>
            <div className="service-icon">{s.icon}</div>
            <h3>{s.title}</h3>
            <p>{s.text}</p>
            <div className="service-tags">
              {s.tags.map((t) => (
                <span key={t}>{t}</span>
              ))}
            </div>
          </article>
        ))}
      </div>

      <div className="hire-cta reveal">
        <div>
          <strong>Have a project or an opening?</strong>
          <span>Usually replies within 24 hours.</span>
        </div>
        <a href="#contact" className="btn btn-primary">Start a conversation</a>
      </div>

      <nav className="service-pages reveal" aria-label="More about working with Kiran">
        {pages.map((p) => (
          <a key={p.slug} href={`/${p.slug}`}>
            <strong>{p.navLabel}</strong>
            <span>{p.description}</span>
          </a>
        ))}
      </nav>
    </div>
  </section>
);

export default Services;
